import { Metamodel, DataFlowDSLAdapterRegistry, Owned } from 'shell-models-lib';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowExpressionUtils } from '../expression.util';
import { BaseFormatAdapter } from './base-format.adapter';
import { AdobePrivacySettings } from 'app/model/dataflow/dataset-settings/adobe-privacy-settings';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { IntegerDataFlowType } from 'app/model/dataflow/dataflow-datatype';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(AdobePrivacySettings)
})
export class AdobePrivacyFormatAdapter extends BaseFormatAdapter<AdobePrivacySettings> {
    protected async toSinkDSL(privacySettings: AdobePrivacySettings): Promise<string[]> {
        const props = [];
        props.push(`format: '${DatasetFormatType.AdobePrivacy}'`);
        if (privacySettings.namespace.expression) {
            props.push(`namespace: ${DataFlowExpressionUtils.wrapExpressionConfigValue(privacySettings.namespace)}`);
        }
        if (privacySettings.namespaceQualifier.expression) {
            props.push(
                `namespaceQualifier: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    privacySettings.namespaceQualifier
                )}`
            );
        }
        if (privacySettings.requestInterval.expression) {
            props.push(
                `requestInterval: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    privacySettings.requestInterval,
                    IntegerDataFlowType.TYPE
                )}`
            );
        }
        return props;
    }

    protected async toSinkModel(
        owner: DataFlowSink,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<AdobePrivacySettings> {
        const privacySettings = Owned.create<AdobePrivacySettings>(AdobePrivacySettings.MODEL, owner);
        privacySettings.initialize(undefined);

        if (configs.has('namespace')) {
            privacySettings.namespace = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('namespace'),
                owner
            );
            handledConfigs.push('namespace');
        }
        if (configs.has('namespaceQualifier')) {
            privacySettings.namespaceQualifier = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('namespaceQualifier'),
                owner
            );
            handledConfigs.push('namespaceQualifier');
        }
        if (configs.has('requestInterval')) {
            privacySettings.requestInterval = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('requestInterval'),
                owner,
                IntegerDataFlowType.TYPE
            );
            handledConfigs.push('requestInterval');
        }

        return privacySettings;
    }
}
